
import { z } from "zod";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { clientFormSchema } from "./ProgramCreationContext";

export function useClientOperations() {
  const { toast } = useToast();

  const updateClientDetails = async (clientId: string | undefined, data: z.infer<typeof clientFormSchema>) => {
    if (!clientId) {
      console.error("No client ID provided for update");
      throw new Error("Client ID is required");
    }

    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        console.error("No authenticated user found");
        throw new Error("Authentication required");
      }

      // Log the data being sent to check for any issues
      console.log("Updating client with data:", data);

      const { error } = await supabase
        .from('clients')
        .update({
          full_name: data.name,
          age: data.age,
          gender: data.gender,
          email: data.email,
          phone: data.phone,
          goals: data.goals,
          notes: data.notes // This should be a string
        })
        .eq('client_id', clientId)
        .eq('coach_id', user.id);

      if (error) {
        console.error("Error updating client:", error);
        throw error;
      }

      console.log("Client updated successfully");
    } catch (error) {
      console.error("Error in updateClientDetails:", error);
      throw error;
    }
  };

  return {
    updateClientDetails,
  };
}
